import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { AutorizacaoLojaService } from './autorizacao-loja.service';
import { OpenpanelAnalyticsService } from './openpanel-analytics.service';

@Injectable({
  providedIn: 'root'
})
export class PresencaCardapioService {
  readonly intervaloAtualizacaoMs = 30000;

  private iniciado = false;
  private estadoInicialVerificado = false;
  private atualizador: any = null;
  private usuarioSub: Subscription;

  constructor(
    private readonly http: HttpClient,
    private readonly analyticsService: OpenpanelAnalyticsService,
    private readonly autorizacaoService: AutorizacaoLojaService
  ) {
    this.usuarioSub = this.autorizacaoService.usuario$.subscribe(() => {
      if (this.iniciado && this.estadoInicialVerificado && !document.hidden) {
        this.registre();
      }
    });
  }

  inicie(): void {
    if (this.iniciado) return;
    this.iniciado = true;

    document.addEventListener('visibilitychange', this.aoAlterarVisibilidade);
    window.addEventListener('pagehide', this.aoSairDaPagina);
    window.addEventListener('pageshow', this.aoRetornarParaPagina);
    this.autorizacaoService.aguardeEstadoInicial().then(() => {
      this.estadoInicialVerificado = true;
      if (this.iniciado) this.sincronizeComVisibilidade();
    });
  }

  pare(): void {
    if (!this.iniciado) return;
    this.iniciado = false;
    this.pareAtualizador();
    document.removeEventListener('visibilitychange', this.aoAlterarVisibilidade);
    window.removeEventListener('pagehide', this.aoSairDaPagina);
    window.removeEventListener('pageshow', this.aoRetornarParaPagina);
  }

  private readonly aoAlterarVisibilidade = (): void => {
    this.sincronizeComVisibilidade();
  };

  private readonly aoSairDaPagina = (): void => {
    this.pareAtualizador();
  };

  private readonly aoRetornarParaPagina = (): void => {
    if (this.iniciado) this.sincronizeComVisibilidade();
  };

  private sincronizeComVisibilidade(): void {
    if (!this.estadoInicialVerificado) return;

    if (document.hidden) {
      this.pareAtualizador();
      return;
    }

    this.registre();
    this.inicieAtualizador();
  }

  private inicieAtualizador(): void {
    this.pareAtualizador();
    this.atualizador = setInterval(() => this.registre(), this.intervaloAtualizacaoMs);
  }

  private pareAtualizador(): void {
    if (!this.atualizador) return;
    clearInterval(this.atualizador);
    this.atualizador = null;
  }

  private registre(): void {
    const idPresenca = this.analyticsService.obtenhaIdSessaoVisita();
    if (!idPresenca) return;

    this.http.post('/api/dashboard/cardapio/presenca', { idPresenca }).subscribe(
      () => undefined,
      () => undefined
    );
  }
}
